import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { getStatusDisplayText } from '@/features/jobs/job-status-display'
import { JobHeading } from '@/features/jobs/details/components/JobHeading'

export interface JobHeadingContainerProps {
  vm: JobDetailsViewModel
}

export const JobHeadingContainer = observer(function JobHeadingContainer({
  vm,
}: JobHeadingContainerProps) {
  const [glyph, tone] = vm.statusGlyph

  return (
    <JobHeading
      eyebrow={vm.heading.eyebrow}
      title={vm.heading.title}
      glyph={glyph}
      tone={tone}
      formattedStatus={getStatusDisplayText(vm.job.status)}
      workspaceName={vm.jobWorkspace.name}
      advanceAllowedDate={vm.actionsVm.advanceAllowedDate}
      dateDeadline={vm.job.dateDeadline}
      since={vm.formattedStatusHistorySummary}
      isDetailsOpen={vm.detailsOpen}
      onDetailsToggle={vm.toggleDetails}
    />
  )
})
